const BASE = '/v1/DefectReason';

export default (instance) => ({
  getDefectReasons: (includeInactive = false) => instance.get(BASE, { params: { includeInactive } }),
  createDefectReason: (data) => instance.post(BASE, data),
  updateDefectReason: (id, data) => instance.put(`${BASE}/${id}`, data),
  deleteDefectReason: (id) => instance.delete(`${BASE}/${id}`)
});
